import {
  getNoticeDatas,
  getVarDatas,
  subEditNotice,
  getEmailSmsDatas,
  setEmailSmsDatas,
  noticeSwitchOpen
} from '@/services/config'
const store = {
  namespaced: true,
  state: {
    tabName: 'system',
    datas: [],
    datasReady: false,
    // 展开id
    expands: [],
    // 开关是否开启请求返回值
    switchStatus: {},
    setSubmitting: false,
    smsEmail: {},
    varDatas: [],
    // 默认数据是否正在加载
    fetching: false,
    projectName: ''
  },
  mutations: {
    setDatas (state, datas) {
      state.datas = datas
      state.datasReady = true
    },
    setVarDatas (state, datas) {
      state.varDatas = datas
    },
    setTabName (state, name) {
      state.tabName = name
    },
    // 设置状态值
    setStatus (state, status) {
      state.switchStatus = status
    },
    // 设置展开id
    changeExpands (state, ids) {
      state.expands = ids
    },
    // 设置短信邮件值
    setSmsEmail (state, datas) {
      state.smsEmail = datas
    },
    setFetching (state, type) {
      state.fetching = type
    },
    setProjectName (state, projectName) {
      state.projectName = projectName
    }
  },
  getters: {
    currentData (state) {
      const { datas, tabName } = state
      datas[tabName] &&
        datas[tabName].forEach((item, index) => {
          item.key = item.id
        })
      return datas[tabName] || []
    }
  },
  actions: {
    // 请求默认数据方法
    // async fetchDatas ({ state, commit }) {
    //   commit('setFetching', true)
    //   const res = await fetchApi(
    //     axios => axios.post('/config/getnotice'),
    //     payload => {
    //       for (let i in payload) {
    //         const data = payload[i]
    //         for (let j in data) {
    //           data[j].status = 1
    //         }
    //       }
    //       commit('setDatas', payload)
    //       commit('setFetching', false)
    //     }
    //   )
    //   if (!res.error) {
    //     commit('setProjectName', res.baseinfo.projectname)
    //   }
    // },
    // 请求系统默认变量数据方法
    // async fetchVarDatas ({ state, commit }) {
    //   await fetchApi(
    //     axios => axios.post('/config/getallow'),
    //     payload => {
    //       commit('setVarDatas', payload)
    //     }
    //   )
    // },

    // 判断是否开启
    // async switchisOpen ({ state, commit }, id) {
    //   let res = await fetchApi(
    //     axios => axios.post('/config/switchnotice', id),
    //     payload => {
    //       commit('setStatus', payload)
    //     }
    //   )
    //   return res
    // },

    // 获取短信邮件
    // async fetchsmsEmailDatas ({ state, commit }) {
    //   await fetchApi(
    //     axios => axios.post('/config/getwarningnum'),
    //     payload => {
    //       commit('setSmsEmail', payload)
    //     }
    //   )
    // },
    // 设置短信邮件
    // async setSmsEmailDatas ({ state, commit }, field) {
    //   await fetchApi(
    //     axios => axios.post('/config/setwarningnum', field),
    //     payload => {
    //       // commit('setSmsEmail', payload)
    //     }
    //   )
    // },
    // 编辑通知
    // async formSubmitAjax ({ state, commit }, field) {
    //   let res = await fetchApi(
    //     axios => axios.post('/config/upnotice', field),
    //     payload => {
    //       // commit('setSmsEmail', payload)
    //     }
    //   )
    //   return res
    // }
    async fetchDatas ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getNoticeDatas()
        .onSuccess(raw => {
          commit('setDatas', raw)
          commit('setFetching', false)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async fetchVarDatas ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getVarDatas()
        .onSuccess(raw => {
          commit('setVarDatas', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async formSubmitAjax ({ commit }) {
      commit('setSubmitting', true)
      const chain = await subEditNotice()
        .onSuccess(raw => {})
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async fetchsmsEmailDatas ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getEmailSmsDatas()
        .onSuccess(raw => {
          commit('setSmsEmail', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async setSmsEmailDatas ({ commit }) {
      commit('setSubmitting', true)
      const chain = await setEmailSmsDatas()
        .onSuccess(raw => {
          // commit('setSmsEmail', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async switchisOpen ({ commit }) {
      commit('setSubmitting', true)
      const chain = await noticeSwitchOpen()
        .onSuccess(raw => {
          commit('setStatus', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    }
  }
}
export default store
